import React from 'react';
import './AddPhoto.css';
import Select from 'react-select';
import {MDBContainer, MDBRow, MDBCol, MDBCard, MDBCardBody, MDBCheckbox} from 'mdb-react-ui-kit';
import {Button} from 'react-bootstrap';

/**
 * La vue qui permet d'ajouter des médias
 * @param {*} props props
 * @return {JSX}
 */
function AddPhotoView(props) {
  const handleCheckboxChange = (event) => {
    props.handleChantierCheckBox();
  };

  return (
    <div className="banktable-container">

      <MDBContainer fluid >
        <MDBRow className="d-flex justify-content-center align-items-center h-100 banktable-modal-content">
          <MDBCol col="12">
            <MDBCard className="bg-dark text-white my-2 mx-auto align-items-center"
              style={{borderRadius: '1rem', maxWidth: '800px'}}>

              <span className="employe-close"
                onClick={() => props.closeModal()}
                style={{fontSize: '35px', cursor: 'pointer', marginRight: '20px', marginTop: '10px'}}>&times;</span>

              <h2 className="fw-bold mb-2 text-uppercase">Ajouter une photo</h2>
              <div style={{display: 'flex'}}>

              </div>
              <MDBCardBody className="mx-auto w-100 addInfo-padding">
                <div className="app" style={{textAlign: 'left', marginTop: '10px'}}>
                  <label className="text-white">Photo</label>
                  <div>
                    <input
                      name="file"
                      type="file"
                      accept="image/*"
                      multiple
                      onChange={props.handleFileChange}
                      className="form-control"
                    />
                  </div>
                </div>
                {props.errors && props.errors.photo && (
                  <span className="error">{props.errors.photo}</span>
                )}
                <div className="app" style={{textAlign: 'center', marginTop: '25px'}}>
                  <label className="text-white">
                    Voir tous les projets ?
                  </label>
                  <div className="toggle-switch" style={{marginBottom: '5px'}}>
                    <div>
                      <input
                        id="toggle"
                        type="checkbox"
                        checked={props.checkedChantier}
                        onChange={handleCheckboxChange}
                      />
                      <label htmlFor="toggle"></label>
                    </div>
                  </div>
                </div>
                <Select
                  name="chantiers"
                  isMulti
                  options={props.placeName}
                  className="form-control addcheckin-form-control-padding"
                  placeholder="Liste des projets"
                  value={props.form.chantier}
                  onChange={props.handleChantierChange}
                  styles={{
                    control: (provided) => ({
                      ...provided,
                      minHeight: '20px',
                      width: '100%',
                    }),
                  }} />
                {props.errors && props.errors.chantier && (
                  <span className="error">{props.errors.chantier}</span>
                )}
                <div style={{marginTop: '28px'}}>
                  <input
                    className="form-control"
                    type="date"
                    name="selectedDate"
                    defaultValue={props.form.selectedDate}
                    onChange={props.handleChangeValue}
                    style={{
                      fontSize: '18px',
                      color: 'black',
                      fontWeight: '450',
                    }} />
                </div>
                <div style={{marginTop: '22px'}}>
                  <MDBCheckbox name='extra1' id='inlineCheckbox11111' label='Extra possible' onChange={props.handleChangeCheckbox} inline />
                  {localStorage.getItem('admin') === '1' ?
                  <React.Fragment>
                    <MDBCheckbox name='extra2' id='inlineCheckbox22222' label='Extra valider' onChange={props.handleChangeCheckbox} inline />
                    <MDBCheckbox name='extra3' id='inlineCheckbox33333' label='Extra confirmer' onChange={props.handleChangeCheckbox} inline />
                  </React.Fragment> : '' }
                  <MDBCheckbox name='avancement' id='inlineCheckbox44444' label='Avancement' onChange={props.handleChangeCheckbox} inline />
                </div>
                <div className="form-group">
                  <textarea
                    type="text"
                    name="note"
                    onChange={props.handleChangeValue}
                    className="form-control"
                    placeholder="Note" />
                </div>
                <Button
                  color="white"
                  size="lg"
                  style={{
                    color: 'white',
                    fontSize: 'calc(10px + 2vmin)',
                    backgroundColor: '#363E46',
                    border: 'none',
                    width: '100%',
                    marginTop: '15px',
                  }}
                  onClick={props.handleSubmit}>
                  Enregistrer
                </Button>
              </MDBCardBody>
            </MDBCard>
          </MDBCol>
        </MDBRow>
      </MDBContainer>
    </div>
  );
}

export default AddPhotoView;
